var clickAddGiftCard = 0;
  function hideGiftcard(){
    if (jQuery('.cart__item').length){
        let countGiftCard = 0;
        jQuery('.cart__item').each(function() {
            let itemTitle = jQuery(this).attr('data-item-title').toLowerCase();
            if (itemTitle.includes('card')) {
                countGiftCard++;
            }
        });
        if (countGiftCard > 0){
            jQuery('.cart-offer__items--gift-card-1').slideUp();
        } else {
            jQuery('.cart-offer__items--gift-card-1').slideDown();
            jQuery('.cart-offer .gift-card-content').slideDown();
            jQuery('.text-area-gift-card').removeClass('active-card');
            jQuery('.cart-offer__item-actions').removeClass('active-card');
            setTimeout(function(){
                jQuery('.owl-carousel').each(function(){
                    jQuery(this).trigger('refresh.owl.carousel');
                });
            }, 500);
        }
    }
  }

  jQuery('body.template-cart').on('DOMSubtreeModified', '.cart__items', function(){
      hideGiftcard();
  });
  jQuery('body').on('DOMSubtreeModified', '.cart-drawer__items', function(){
      hideGiftcard();
  });

  
document.addEventListener('theme:cart:added', function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.Header__CartCount').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('.Header__CartDot').forEach(function (el) {
        el.classList.toggle('is-visible', cart.item_count > 0);
      });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    jQuery('body').on('click', '.cart-offer__items--gift-card .gift-card-content .btn', function(){
        // jQuery(this).parent().hide();
        jQuery(this).closest('.gift-card-content').slideUp();
        jQuery(this).parent().next().removeClass('hide');
        jQuery('.owl-carousel').each(function(){
            jQuery(this).trigger('refresh.owl.carousel');
        });
        return false;
    });

    jQuery.fn.onClassChange = function(cb) {
      return $(this).each((_, el) => {
        new MutationObserver(mutations => {
          mutations.forEach(mutation => cb && cb(mutation.target, $(mutation.target).prop(mutation.attributeName)));
        }).observe(el, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
    jQuery('#cart-drawer').onClassChange(function(){
        if(clickAddGiftCard == 1) {
          let listInput = [...document.querySelectorAll('.card-text-area')];
          setTimeout(function(){
              listInput.forEach(ele => {
                ele.value = null;
                ele.nextElementSibling.firstElementChild.disabled = true;
                ele.nextElementSibling.classList.add('disabled');
                ele.nextElementSibling.firstElementChild.classList.add('disabled');
              });
          },100);
          clickAddGiftCard = 0;
        }
    });
});



jQuery(window).on('load', function(){
    if ($('body.template-cart').length) {
        if (jQuery('.cart-offer__items-upsell-slider .cart-offer__item-wrapper').length) {
            jQuery('.cart-offer__items-upsell-slider').owlCarousel({
                nav: true,
                responsiveClass:true,
                responsive:{
                  0: {
                    margin: 25,
                    stagePadding: 40
                  },
                  768: {
                    margin: 35,
                    stagePadding: 55
                  }
                },
                loop: true,
                items:2,
                dots: false,
            })
        }
        
        if (jQuery('.cart-offer__items-gift-slider .cart-offer__item-wrapper').length) {
            jQuery('.cart-offer__items-gift-slider').owlCarousel({
                nav: true,
                loop: true,
                items:1,
                dots: false
            })
        }
    }
});


  function setState() {
    clickAddGiftCard = 1;
  }

  let tHeight;
  function buttonState(e) {
    if(e.value) {
      e.nextElementSibling.firstElementChild.disabled = false;
      e.nextElementSibling.classList.remove('disabled');
      console.log(e.nextElementSibling.firstElementChild);
      e.nextElementSibling.firstElementChild.classList.remove('disabled');
    } else {
      e.nextElementSibling.firstElementChild.disabled = true;
      e.nextElementSibling.classList.add('disabled');
      console.log(e.nextElementSibling.firstElementChild);
      e.nextElementSibling.firstElementChild.classList.add('disabled');
    }
  }
  function toggleCard (e) {
    if (e.closest('.toggle-button-card').classList.contains('active-card'))
          {
            e.closest('.toggle-button-card').classList.remove('active-card');
            e.closest('.cart-offer__items').nextElementSibling.classList.remove('active-card');
          } else {
            e.closest('.toggle-button-card').classList.add('active-card');
            e.closest('.cart-offer__items').nextElementSibling.classList.add('active-card');
    }
  }